import { GlobalFunctionsService } from '@_services/global-functions.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { ChangeDetectionStrategy, Component, inject, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-api-access-popup',
  templateUrl: './api-access-popup.component.html',
  styleUrls: ['./api-access-popup.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ApiAccessPopupComponent implements OnInit {
  private _formBuilder = inject(FormBuilder);
  private toastr = inject(ToastrService);
  private _mainAPiServiceService = inject(MainAPiServiceService);
  private globalFunService = inject(GlobalFunctionsService);
  private dialogRef = inject(MatDialogRef<ApiAccessPopupComponent>);
  readonly _data = inject(MAT_DIALOG_DATA);
  private _unsubscribeAll$: Subject<void> = new Subject();
  ApiAccessPopup: FormGroup;
  isLoadingResults: boolean;
  dataAPi: any;

  ngOnInit(): void {
    this.ApiAccessPopup = this._formBuilder.group({
      APPLICATIONGUID: [''],
      APPLICATIONNAME: [''],
      APPLICATIONDESCRIPTION: [''],
      REDIRECTURL: [''],
      REDIRECTURL2: [''],
      REDIRECTURL3: [''],
      ISACTIVE: [true],
      ALLOWPUBLICCLIENT: [false],
      REGENERATECLIENTSECRET: [false],
    });
    if (this._data.Type === 'edit' && this._data.Application) {
      this.ApiAccessPopup.patchValue(this._data.Application);
    }
  }

  registerApplication(): void {
    this.isLoadingResults = true;
    const action = this._data.Type === 'edit' ? 'updateapplication' : 'registerapplication';

    const payload: any = {
      APPLICATIONNAME: this.ApiAccessPopup.value.APPLICATIONNAME,
      APPLICATIONDESCRIPTION: this.ApiAccessPopup.value.APPLICATIONDESCRIPTION,
      REDIRECTURL: this.ApiAccessPopup.value.REDIRECTURL,
      REDIRECTURL2: this.ApiAccessPopup.value.REDIRECTURL2,
      REDIRECTURL3: this.ApiAccessPopup.value.REDIRECTURL3,
      ALLOWPUBLICCLIENT: this.ApiAccessPopup.value.ALLOWPUBLICCLIENT,
    };
    if (action == 'updateapplication') {
      payload.APPLICATIONGUID = this.ApiAccessPopup.value.APPLICATIONGUID;
    }
    if (
      this.ApiAccessPopup.value.ISACTIVE !== null &&
      this.ApiAccessPopup.value.ISACTIVE !== undefined &&
      action == 'updateapplication'
    ) {
      payload.ISACTIVE = this.ApiAccessPopup.value.ISACTIVE;
    }

    if (
      this.ApiAccessPopup.value.REGENERATECLIENTSECRET !== null &&
      this.ApiAccessPopup.value.REGENERATECLIENTSECRET !== undefined &&
      action == 'updateapplication'
    ) {
      payload.REGENERATECLIENTSECRET = this.ApiAccessPopup.value.REGENERATECLIENTSECRET;
    }

    this.dataAPi = {
      Action: action,
      Data: payload,
      ValidateOnly: true,
    };

    this._mainAPiServiceService.getSetData(this.dataAPi, 'oauth2/apps').subscribe({
      next: (response: any) => {
        this.isLoadingResults = false;
        if (response.CODE === 200 && response.STATUS === 'success') {
          this.checkTaskPackItemValidation(
            response.DATA.VALIDATIONS,
            this.dataAPi,
            'oauth2/apps',
            action,
          );
        } else {
          this.checkTaskPackItemValidation(
            response.DATA.VALIDATIONS,
            this.dataAPi,
            'oauth2/apps',
            action,
          );
        }
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  async checkTaskPackItemValidation(
    bodyData: any,
    details: any,
    APIURL: any,
    Action: any,
  ): Promise<void> {
    await this.globalFunService
      .checkValidation(bodyData, details)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((data) => {
        if (data) {
          if (data.callback) {
            this.saveTaskPacketsItemData(details, APIURL, Action);
          }
        }
      });
  }

  saveTaskPacketsItemData(data: any, APIURL: string, Action): void {
    data.ValidateOnly = false;
    this._mainAPiServiceService
      .getSetData(data, APIURL)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe(
        (response) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.dialogRef.close({
              success: true,
              secret: response.DATA?.CLIENTSECRET,
              regenerated: this.ApiAccessPopup.value.REGENERATECLIENTSECRET,
              isNew: this._data.Type === 'new',
            });
            if (Action == 'registerapplication') {
              this.toastr.success('Saved successfully');
            } else {
              this.toastr.success('Updated successfully');
            }
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
          } else if (response.MESSAGE == 'Not logged in') {
            this.dialogRef.close(false);
          }
        },
        (error) => {
          this.toastr.error(error);
        },
      );
  }
}
